import React from 'react'
import { ProductMessageItem } from '../../ChatMessages/types'
import { ConciergeCardTileContent } from '../ConciergeCardTileContent'
import { StyledCardButton, StyledCardLink } from './styled'

type ConciergeCardTileProps = {
  item: ProductMessageItem
  itemId?: string
  onTileClick?: (item: ProductMessageItem) => void
}

export const ConciergeCardTile = ({
  item,
  onTileClick,
}: ConciergeCardTileProps) => {
  if (item.productUrl) {
    return (
      <StyledCardLink
        aria-label={item.title}
        draggable={false}
        href={item.productUrl}
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
          onTileClick?.(item)
        }}
        rel="noreferrer noopener"
        target="_blank"
      >
        <ConciergeCardTileContent
          imageUrl={item.imageUrl}
          title={item.title}
          onTileClick={() => onTileClick?.(item)}
        />
      </StyledCardLink>
    )
  }

  return (
    <StyledCardButton
      type="button"
      aria-label={item.title}
      onClick={() => onTileClick?.(item)}
    >
      <ConciergeCardTileContent
        imageUrl={item.imageUrl}
        title={item.title}
        onTileClick={() => onTileClick?.(item)}
      />
    </StyledCardButton>
  )
}
